export default __webpack_public_path__ + "static/media/cardPreviewPlaceholder.1227b3e3.svg";